// legacyFeatureFlags.js

/**
 * Legacy `_library` / dictionary product surfaces.
 * Hidden during Store v1; backend callables and admin code are retained.
 */
export const LEGACY_LIBRARY_UI_ENABLED = false;
